"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGolfLinkedLineUrl = void 0;
const dayjs = require("dayjs");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getGolfLinkedLineUrl = (item, order_id) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    const config = latest_version.config;
    let course_name = "";
    if (config.course.name) {
        course_name = config.course.name.en;
    }
    let course_id = "";
    if (config.course.id) {
        course_id = config.course.id;
    }
    return `/orders/${order_id}/transfer?date=${dayjs(config.where_when_who.date).format("YYYY-MM-DD")}${config.where_when_who.region_id &&
        `&region_id=${encodeURIComponent(config.where_when_who.region_id)}&linked_line_id=${encodeURIComponent(item.id)}&number_of_passengers=${encodeURIComponent(config.where_when_who.number_of_golfers)}&to_area=${encodeURIComponent(course_id)}&to_name=${encodeURIComponent(course_name)}&to_type=Course&from_area=${encodeURIComponent(course_id)}&from_name=${encodeURIComponent(course_name)}&from_type=Course`}`;
};
exports.getGolfLinkedLineUrl = getGolfLinkedLineUrl;
